import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

export interface SubscriptionPlan {
  id: string;
  name: string;
  description?: string;
  interval?: 'Yearly' | 'Monthly' | 'Special' | 'Addon';
  amount: number;
  currency: string;
  credits: number;
  planExpiration: string;
  isDeprecated: boolean;
  discountPercent?: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  planUniqueId: string;
  featureRestriction?: Array<any>;
}

interface Payload {
  specificPlan?: string;
  lifetimeVisibility?: 'all' | 'owned' | 'none';
}

export const getSubscriptionPlans = async ({
  specificPlan,
  lifetimeVisibility,
}: Payload): Promise<Array<SubscriptionPlan>> => {
  const queryParts: string[] = [];
  if (specificPlan) queryParts.push(`planFilter=${encodeURIComponent(specificPlan)}`);
  if (lifetimeVisibility)
    queryParts.push(`lifetimeVisibility=${encodeURIComponent(lifetimeVisibility)}`);
  const query = queryParts.length ? `?${queryParts.join('&')}` : '';
  const response = await axiosInstance.get(`/api/payments/active-plans${query}`);
  return response.data;
};

export const useGetSubscriptionPlans = (
  specificPlan = '',
  lifetimeVisibility?: 'all' | 'owned' | 'none'
) => {
  return useQuery(['fetchSubsPlans', specificPlan, lifetimeVisibility], () =>
    getSubscriptionPlans({ specificPlan, lifetimeVisibility })
  );
};
